export default __webpack_public_path__ + "static/media/terapias-de-realidad-virtual.a6cd4e21.jpg";